import React, { useCallback, useState, createContext, useContext } from 'react';
import { SidePanel } from "../SidePanel";
export var PageWizardPanelContext = createContext({
    activate: function () {
        // no-op
    },
    deactivate: function () {
        // no-op
    },
    element: null,
    isShrink: false
});
export function PageWizardPanelProvider(_a) {
    var children = _a.children;
    var _b = useState(null), element = _b[0], setPanel = _b[1];
    var _c = useState(false), isShrink = _c[0], setIsShrink = _c[1];
    var deactivate = useCallback(function () {
        setPanel(null);
    }, []);
    var activate = useCallback(function (el, config) {
        setPanel(el);
        setIsShrink(!!(config === null || config === void 0 ? void 0 : config.isShrink));
    }, []);
    return React.createElement(PageWizardPanelContext.Provider, {
        value: { deactivate: deactivate, activate: activate, element: element, isShrink: isShrink }
    }, children);
}
export function usePageWizardPanel(_a) {
    var title = _a.title, description = _a.description, shrink = _a.shrink, onClose = _a.onClose, render = _a.render;
    var panelApi = useContext(PageWizardPanelContext);
    var deactivate = useCallback(function () {
        panelApi.deactivate();
    }, []);
    var activate = function (config) {
        var content = render({ deactivate: deactivate, data: config === null || config === void 0 ? void 0 : config.data });
        if (!content) {
            return;
        }
        panelApi.activate(React.createElement(SidePanel, {
            title: (config === null || config === void 0 ? void 0 : config.title) || title,
            description: (config === null || config === void 0 ? void 0 : config.description) || description,
            onRequestClose: function () {
                deactivate();
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        }, content), { isShrink: shrink });
    };
    return {
        activate: activate,
        deactivate: deactivate,
        isShown: !!panelApi.element
    };
}
//# sourceMappingURL=hooks.js.map